@import '../../styles/host.css';

:host {
    display: block;
    margin: var(--protean-select-margin, 1rem);
}

.select-container {
    display: block;
    position: relative;
}

protean-input {
    margin: 0;
    cursor: pointer;
}

.protean-select-icon {
    position: absolute;
    right: 0.75rem;
    bottom: 0.25rem;
}

:host([disabled]) .protean-select-icon {
    opacity: 0.4;
    cursor: not-allowed;
}

.protean-dropdown {
    position: absolute;
    z-index: 2;
    top: calc(100% - 3px);
    width: 100%;
    background-color: var(--protean-dropdown-background-color, #1a1a1a);
    color: var(--protean-dropdown-text-color, #fafafa);
    border-width: var(--protean-dropdown-border-width, 0 1px 1px);
    border-style: solid;
    border-color: var(--protean-dropdown-border-color, currentColor);
    border-radius: 0 0 2px 2px;
    box-shadow: var(
        --protean-dropdown-box-shadow,
        0 3px 5px -2px rgba(255, 255, 255, 0.7)
    );
    max-height: 250px;
    overflow-y: scroll;
}

.protean-select-separator {
    height: 1px;
    width: calc(100% - 20px);
    margin: 0 auto;
    position: relative;
    top: -2px;
    z-index: 3;
    background-color: var(--protean-select-separator-color, #535353);
}
